<div class="container">
  <button
    class="back-button p-button p-button-primary p-button-sm"
    (click)="goBack()">
    <i class="ri-arrow-left-s-line"></i>
    <span i18n="@@backToMapButton">Back to Map</span>
  </button>

  <app-user-menu></app-user-menu>

  <div class="content">
    <app-mapbox-header
      [submittedDate]="heroReport.createdDate"
      [reporter]="heroReport.pocName || 'Unknown'"
      [longitude]="heroReport.longitude"
      [latitude]="heroReport.latitude"
      [status]="heroReport.status"
      [classification]="classificationLabel"
      [possibleIdentification]="heroReport.possibleIdentification">
    </app-mapbox-header>

    <div class="panel-container">
      <div class="button-container">
        <button
          *ngIf="canViewEOD && heroReport.eodIncidentReport"
          pButton
          label="View EOD Report"
          i18n-label="@@viewEodReportButton"
          [outlined]="true"
          class="eod-incident-button p-button-sm"
          [routerLink]="[
            '/hero-report',
            heroReport.id,
            'incident',
            heroReport.eodIncidentReport.id
          ]"
          type="button">
        </button>

        <button
          *ngIf="canDeleteHero"
          pButton
          label="Delete Hero Report"
          i18n-label="@@deleteHeroReportButton"
          class="delete-button p-button p-button-danger p-button-sm"
          (click)="deleteHeroReport()">
        </button>

      </div>

      <app-sre-report-view
        *ngIf="isSre"
        [heroReport]="heroReport"
        [canEdit]="canEditHero">
      </app-sre-report-view>

      <p-tabView
        *ngIf="!isSre"
        [(activeIndex)]="activeTabIndex"
        (onChange)="onTabChange($event)">

        <!-- ITEM TAB -->
        <p-tabPanel header="Item" i18n-header="@@itemTab" [disabled]="isTabDisabled(0)">

          <!-- EDIT MODE -->
          <div *ngIf="currentlyEditingTab === 0; else itemViewMode">
            <div style="max-width: 600px">
              <app-item-form
                [formGroup]="itemForm"
                [overallImages]="overallImages"
                [noseImages]="noseImages"
                [tailImages]="tailImages"
                (imagesAdd)="onItemImageAdd($event)"
                (imagesDelete)="onItemImageDelete($event)"
                [deleteable]="false"
                [showLocation]="true">
              </app-item-form>

              <div style="display: flex; justify-content: space-between">
                <button
                  pButton
                  label="Cancel"
                  i18n-label="@@cancelButton"
                  class="p-button-sm p-button-text"
                  (click)="cancelEdit(0)"
                  type="button">
                </button>

                <button
                  pButton
                  label="Save"
                  i18n-label="@@saveButton"
                  class="p-button-sm p-button-primary"
                  (click)="saveTab(0)"
                  type="button">
                </button>

              </div>
            </div>
          </div>

          <!-- VIEW MODE -->
          <ng-template #itemViewMode>
            <app-input-display-grid
              [values]="itemRows"
              [columnLength]="2">
            </app-input-display-grid>

            <div style="margin-top: 1rem">
              <app-display-images [images]="images"></app-display-images>
            </div>

            <div style="margin-top: 1rem; text-align: right">
              <button
                *ngIf="canEditHero"
                pButton
                icon="ri-pencil-line"
                class="p-button-sm p-button-primary"
                (click)="editTab(0)"
                type="button"
                label="Edit"
                i18n-label="@@editButton">
              </button>

            </div>
          </ng-template>
        </p-tabPanel>

        <!-- EVENT TAB -->
        <p-tabPanel header="Event" i18n-header="@@eventTab" [disabled]="isTabDisabled(1)">

          <div *ngIf="currentlyEditingTab === 1; else eventViewMode">

            <div style="max-width: 500px">
              <app-event-form [formGroup]="eventForm"></app-event-form>

              <div style="display: flex; justify-content: space-between">
                <button
                  pButton
                  label="Cancel"
                  i18n-label="@@cancelButton"
                  class="p-button-sm p-button-text"
                  (click)="cancelEdit(1)"
                  type="button">
                </button>

                <button
                  pButton
                  label="Save"
                  i18n-label="@@saveButton"
                  class="p-button-sm p-button-primary"
                  (click)="saveTab(1)"
                  type="button">
                </button>

              </div>
            </div>
          </div>

          <ng-template #eventViewMode>
            <app-input-display-grid
              [values]="standardOptions"
              [columnLength]="2">
            </app-input-display-grid>

            <div style="margin-top: 1rem; text-align: right">
              <button
                *ngIf="canEditHero"
                pButton
                icon="ri-pencil-line"
                class="p-button-sm p-button-primary"
                (click)="editTab(1)"
                type="button"
                label="Edit"
                i18n-label="@@editButton">
              </button>

            </div>
          </ng-template>
        </p-tabPanel>

        <!-- EVACUATION TAB -->
        <p-tabPanel header="Evacuation" i18n-header="@@evacuationTab" [disabled]="isTabDisabled(2)">

          <div *ngIf="currentlyEditingTab === 2; else evacViewMode">

            <div style="max-width: 500px">

              <app-evacuation-form [formGroup]="evacuationForm"></app-evacuation-form>

              <div style="display: flex; justify-content: space-between">
                <button
                  pButton
                  label="Cancel"
                  i18n-label="@@cancelButton"
                  class="p-button-sm p-button-text"
                  (click)="cancelEdit(2)"
                  type="button">
                </button>

                <button
                  pButton
                  label="Save"
                  i18n-label="@@saveButton"
                  class="p-button-sm p-button-primary"
                  (click)="saveTab(2)"
                  type="button">
                </button>

              </div>
            </div>
          </div>

          <ng-template #evacViewMode>
            <app-input-display-grid
              [values]="evacuationOptions1"
              [columnLength]="2">
            </app-input-display-grid>

            <app-input-display-grid
              *ngIf="evacuationOptions2 && evacuationOptions2.length > 0"
              [values]="evacuationOptions2"
              [columnLength]="2">
            </app-input-display-grid>

            <app-input-display-grid
              [values]="evacuationOptions3"
              [columnLength]="2">
            </app-input-display-grid>

            <div style="margin-top: 1rem; text-align: right">
              <button
                *ngIf="canEditHero"
                pButton
                icon="ri-pencil-line"
                class="p-button-sm p-button-primary"
                (click)="editTab(2)"
                type="button"
                label="Edit"
                i18n-label="@@editButton">
              </button>

            </div>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>